import { render, staticRenderFns } from "./DashboardCL.vue?vue&type=template&id=77735b60&scoped=true&"
import script from "./DashboardCL.vue?vue&type=script&lang=js&"
export * from "./DashboardCL.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCL.vue?vue&type=style&index=0&id=77735b60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77735b60",
  null
  
)

export default component.exports